import {
  uploadAudio,
  addSpeechActivitiesByCourseAndAssignee,
} from "../store/study/studyBaseApi";

export const updateSpeakAloudActivity = async ({
  speechList = [],
  profileId,
  chapterId,
  sectionId,
  start,
  end,
  courseId,
  type = "SPEAK_ALOUD",
}) => {
  // console.log("data", speechList, profileId, chapterId, sectionId, start, end, courseId, type);

  for (let i = 0; i < speechList.length; i++) {
    let url = "";
    // No recording (e.g. the dev skip) — nothing to upload.
    if (speechList[i].audioUrl) {
      const formData = new FormData();
      formData.append("file", speechList[i].audioUrl);
      formData.append("path", `IR-SERVICE/AUDIO`);

      try {
        const resp = await uploadAudio({
          id: profileId,
          formData,
          type: "audio",
        });
        url = resp.data;
      } catch (e) {
        console.log("error", e);
      }
    }

    let body = {
      assigneeId: profileId,
      courseId,
      sectionId,
      chapterId: chapterId,
      endTime: end,
      startTime: start,
      type,
      speakAloud: [
        {
          audio: url,
          sentance: speechList[i]?.text,
          outcome: speechList[i]?.outcome,
          readingScore: speechList[i]?.score,
          // Per-sentence retry count (incorrect attempts before acceptance). Rides
          // alongside readingScore; ignored by every average-score computation.
          retryCount: speechList[i]?.retryCount,
        },
      ],
    };

    await addSpeechActivitiesByCourseAndAssignee({
      params: { courseId, assigneeId: profileId },
      body: body,
    });
  }
};
